import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { useTranslation } from 'react-i18next';

import useCartFooter from './hooks/useCartFooter';

interface Props {
    shopId: string;
    cartId?: string;
}

function CartFooter({ shopId, cartId }:Props) {
    const { t } = useTranslation('cart');
    const {
        handleOrder, totalAmount, isEmpty, isAllSoldOuted,
    } = useCartFooter({ shopId, cartId });
    const priceUnit = usePriceUnit();
    return (
        <Column spacing={4} fullWidth>
            <Column spacing={2} fullWidth>
                <Row justify='space-between' fullWidth>
                    <Text size='title' color='var(--color-text-secondary)' fontWeight='bold'>
                        {t('footer.productAmount')}
                    </Text>
                    <Text size='title'>{totalAmount.toLocaleString()}{priceUnit}</Text>
                </Row>
                <Row justify='space-between' fullWidth>
                    <Text size='title' fontWeight='bold'>
                        {t('footer.paymentAmount')}
                    </Text>
                    <Text size='display' fontWeight='bold' color='var(--color-text-error)'>
                        {totalAmount.toLocaleString()}{priceUnit}
                    </Text>
                </Row>
            </Column>
            <Button fullWidth onClick={handleOrder}
                id='cart-order-button'
                disabled={isAllSoldOuted || isEmpty} >
                {isAllSoldOuted ? t('footer.soldOut') : t('footer.order')}
            </Button>
        </Column>
    );
}

export default CartFooter;
